// extracted by mini-css-extract-plugin
export default {"qbankLink":"HeaderQBankLink_qbankLink__zIqvo","qbankLinkActive":"HeaderQBankLink_qbankLinkActive__cbrtk","qbankIcon":"HeaderQBankLink_qbankIcon__lfdym"};